import React, { useState, useRef, useEffect } from 'react'
import ActiveAuction from './ActiveAuction'
import WonAuction from './wonAuction'
import LostAuction from './LostAuction'
import InvoiceList from './InvoiceList'
import BuyNow from './BuyNow'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Dashboard from '../Dashboard/Dashboard'
import { getbuyerDashboard } from '../../Utils/API/MyAuctions'
import { getbuynow } from '../../Utils/API/buynow'
import axios from '../../Utils/Utility/axiosconfig'
import { connect } from 'react-redux'
import Swal from 'sweetalert2'
import './MyAuction.css'
import isAuthenticate from '../../Utils/Utility/auth'
import { useHistory, useLocation } from 'react-router-dom'
import Commondropdown from '../../components/atoms/DropDown/commondropdown'
import moment from 'moment'
import { values } from 'lodash'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRange, DateRangePicker } from 'react-date-range'
import { enUS } from 'date-fns/locale'
import { format } from 'date-fns'

import {
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
} from 'date-fns'
import { useMediaQuery } from 'react-responsive'
// import { useMediaQuery } from '@material-ui/core'

// const defineds = {
//     startOfWeek: startOfWeek(new Date()),
//     endOfWeek: endOfWeek(new Date()),
//     startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
//     endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
//     startOfToday: startOfDay(new Date()),
//     endOfToday: endOfDay(new Date()),
//     startOfYesterday: startOfDay(addDays(new Date(), -1)),
//     endOfYesterday: endOfDay(addDays(new Date(), -1)),
//     startOfMonth: startOfMonth(new Date()),
//     endOfMonth: endOfMonth(new Date()),
//     startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
//     endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
// }

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
})

const MyAuction = (props) => {
    const classes = useStyles()
    const search = useLocation().search
    const params = new URLSearchParams(search)
    const [value, setValue] = useState(params.get('s') ? parseInt(params.get('s')) : 0)
    const [activeBody, setActiveBody] = useState([])
    const [bidwon, setSoldBody] = useState([])
    const [bidWonData, setBidWonData] = useState([])
    // const [body, setBody] = useState({})
    const [bidlost, setUnsoldBody] = useState([])
    const [buynow, setbuynow] = useState([])
    const [sortbyorder, setSortByOrder] = useState('0')
    const [reload, setReload] = useState(false)
    const [sorttype, setSortType] = useState('down')
    const history = useHistory()

    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        },
    ])

    const [activebodyparams, setactivebodyparams] = useState({
        sh_limit: 10,
        page: 1,
        status: 'bidactive',
    })

    const [bidwonbodyparams, setbidwonbodyparams] = useState({
        sh_limit: 10,
        page: 1,
        status: 'bidwon',
        sub_status: 0,
    })

    const [bidlostbodyparams, setbidlostbodyparams] = useState({
        sh_limit: 10,
        page: 1,
        status: 'bidwon',
        sub_status: 1,
    })

    const [buynowbodyparams, setbuynowbodyparams] = useState({
        sh_limit: 10,
        page: 1,
        status: 'buynow',
    })

    useEffect(() => {
        console.log('props-------------', props.history.location.state)
        if (props.history.location.state != null || props.history.location.state != undefined) {
            setValue(props.history.location.state.value)
        }
    }, [])

    useEffect(() => {
        if (isAuthenticate()) {
            getData(activebodyparams, setActiveBody)
        } else {
            history.push('/login')
        }
    }, [activebodyparams])

    useEffect(() => {
        if (isAuthenticate()) {
            getData(bidwonbodyparams, setSoldBody)
        } else {
            history.push('/login')
        }
    }, [bidwonbodyparams])

    useEffect(() => {
        if (isAuthenticate()) {
            getData(bidlostbodyparams, setUnsoldBody)
        } else {
            history.push('/login')
        }
    }, [bidlostbodyparams])

    useEffect(() => {
        if (isAuthenticate()) {
            getbuynowdata(buynowbodyparams, setbuynow)
        } else {
            history.push('/login')
        }
    }, [buynowbodyparams])

    const getData = async (body, setData) => {
        let data = await getbuyerDashboard(body)
        if (body.status === 'bidactive') {
            data.results = data.results.reverse()
        }
        if (body.sub_status === 0) {
            setBidWonData(data.results)
        }
        if (typeof data !== 'string') {
            setData(data)
        }
    }

    const getbuynowdata = async (body, setData) => {
        let data = await getbuynow(body)
        if (typeof data !== 'string') {
            setData(data)
        }
    }

    const handleChange = (event, newValue) => {
        history.push(`/dashboard?s=${newValue}`)
    }
    useEffect(() => {
        setValue(params.get('s') ? parseInt(params.get('s')) : 0)
    }, [window.location.search])

    useEffect(() => {
        console.log('bidding', props.bidding.bidding, props.userDetails)
        let bidUpdate = props.bidding.bidding
        let activeBids = activeBody.results
        if (bidUpdate.id) {
            if (props.userDetails) {
                let lotIndex = activeBids?.findIndex((ele) => bidUpdate.id == ele.id)
                if (lotIndex >= 0 && props.userDetails.userdetails.id === bidUpdate.bpop_higher) {
                    activeBids[lotIndex].highest_bidder_user_id = bidUpdate.bpop_higher
                    activeBody.results = activeBids
                    setActiveBody(activeBody)
                }
            }
        }
        setReload(!reload)
    }, [props.bidding])

    const retractBid = async (bid) => {
        console.log('retractBid', bid)
        if (bid.mybidid && props.userDetails) {
            const formdata = new FormData()

            formdata.append('pid', bid.id)
            formdata.append('id', bid.mybidid)
            formdata.append('uid', props.userDetails.userdetails.id)
            formdata.append('price', bid.mybid)
            formdata.append('auctionid', bid.auctionid)
            formdata.append('lotof', bid.lotof)
            formdata.append('is_buyer', true)
            console.log('retractBid', formdata)
            const res = await axios.post(`api_bidding/cancelbid_process`, formdata)
            if (res.data.msg === 'yes') {
                Swal.fire({
                    title: 'Bid Retracted Successfully',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
                getData(activebodyparams, setActiveBody)
            }
        }
    }

    // const handleSortChange = (e) => {
    //     setSortByOrder(e.target.value)
    //     sessionStorage.setItem('sortBy', e.target.value)
    //     setBody({
    //         limit: 'pageLotCount',
    //         page: 1,
    //         lotof: '',
    //         order: 1,
    //         userid: '',
    //         searchbar_with_lot_number: '',
    //         orderby: e.target.value,
    //     })
    //     let query = new URLSearchParams(props.location.search)
    //     query.set('scrollLocation', 0)
    //     query.set('page', 1)
    //     query.set('sortby', e.target.value)
    //     history.replace({
    //         pathname: props.location.pathname,
    //         search: '?' + query.toString(),
    //     })
    // }

    // const searchResultCountround = [
    //     { id: '0', data: 'No Invoice' },
    //     { id: '1', data: bidWonData.startDate || '' },
    //     { id: '2', data: bidWonData.startDate || '' },
    // ]

    // const searchResultCountround = [
    //     { id: '0', data: 'Select' },
    //     ...bidWonData.map((date, index) => ({
    //         id: String(index + 1),
    //         data: moment(date.date_closed).format('MM/DD/YYYY'),
    //     })),
    // ]

    // useEffect(() => {
    //     setBody({
    //         limit: '100',
    //         lotof: '0',
    //         orderby: '0',
    //         page: 1,
    //         order: 1,
    //         searchbar_with_lot_number: '',
    //     })
    // }, [props.location.search])

    // const handleSortChange = (e) => {
    //     setSortByOrder(e.target.value)
    //     let query = new URLSearchParams(props.location.search)
    //     query.set(e.target.name, e.target.value)
    //     query.set('page', 1)
    //     history.push({ pathname: '/dashboard', search: '?' + query.toString() })
    // }

    const [showPicker, setShowPicker] = useState(false)
    useEffect(() => {
        console.log(showPicker, 'showPicker')
    }, [showPicker])
    // Default range = today
    const defaultRange = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    }

    const [range, setRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    })

    const pickerRef = useRef(null)

    // Close picker if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setShowPicker(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const togglePicker = () => setShowPicker((prev) => !prev)

    const handleSelect = (ranges) => {
        const start = ranges.selection.startDate
        const end = ranges.selection.endDate

        // update the date range state for the picker
        setRange(ranges.selection)

        // update the payload
        setbidwonbodyparams((prev) => ({
            ...prev,
            fromDate: format(start, 'yyyy-MM-dd'),
            toDate: format(end, 'yyyy-MM-dd'),
        }))

        setShowPicker(false) // close dropdown if using button picker
    }

    const handleReset = () => {
        setRange(defaultRange)
        setbidwonbodyparams((prev) => ({
            ...prev,
            fromDate: '',
            toDate: '',
        }))
        setShowPicker(false)
    }

    const isMobile = useMediaQuery({
        query: '(max-width: 600px)',
    })

    return (
        <div>
            <Dashboard>
                <div className="Dashboard-Tabpanel">
                    <div className="dashBoardGridContainer">
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label="Active Lots" />
                            <Tab label="Won Lots" />
                            <Tab label="Invoice" />
                            {/* <Tab label="Lost Lots" /> */}
                        </Tabs>
                        {value === 1 && (
                            <div className="dashbordSort">
                                <label>{isMobile ? null : 'Sort By Auction : '}</label>
                                <button
                                    className="dateRangeBtn"
                                    onClick={togglePicker}
                                    style={{
                                        padding: '8px 16px',
                                        border: '1px solid #ececec',
                                        fontWeight: 500,
                                    }}
                                >
                                    {bidwonbodyparams.fromDate && bidwonbodyparams.toDate
                                        ? `${format(range.startDate, 'MM/dd/yyyy')} - ${format(
                                              range.endDate,
                                              'MM/dd/yyyy',
                                          )}`
                                        : isMobile
                                        ? 'Sort Date Range'
                                        : 'Select Date Range'}
                                </button>
                                <button
                                    onClick={handleReset}
                                    style={{
                                        marginLeft: '8px',
                                        border: '1px solid #ececec',
                                        padding: '8px 16px',
                                    }}
                                >
                                    Reset
                                </button>
                                {showPicker && (
                                    <div
                                        ref={pickerRef}
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 'auto',
                                            right: 0,
                                            zIndex: 1000,
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        }}
                                    >
                                        <DateRange
                                            ranges={[range]}
                                            onChange={handleSelect}
                                            locale={enUS}
                                            editableDateInputs={true}
                                            rangeColors="#003380cf"
                                            color="#003380cf"
                                        />
                                    </div>
                                )}

                                {/* <Commondropdown
                                        selected={sortbyorder}
                                        values={searchResultCountround}
                                        name="orderby"
                                        handleChange={handleSortChange}
                                    /> */}
                            </div>
                        )}
                    </div>
                    <TabPanel value={value} index={0}>
                        <ActiveAuction
                            data={activeBody}
                            paramsupd={(data) => {
                                setactivebodyparams({ ...activebodyparams, page: data })
                            }}
                            retractBid={retractBid}
                            userDetails={props.userDetails}
                            setSortType={setSortType}
                            sorttype={sorttype}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <WonAuction
                            data={bidwon}
                            paramsupd={(data) => {
                                setbidwonbodyparams({ ...bidwonbodyparams, page: data })
                            }}
                        />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <InvoiceList
                            data={bidlost}
                            paramsupd={(data) => {
                                setbidwonbodyparams({ ...bidlostbodyparams, page: data })
                            }}
                            user={props.userDetails}
                        ></InvoiceList>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <BuyNow
                            data={buynow}
                            paramsupd={(data) => {
                                setbuynowbodyparams({ ...buynowbodyparams, page: data })
                            }}
                        />
                    </TabPanel>
                </div>
            </Dashboard>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.User ? state.User : {},
        bidding: state.bidding ? state.bidding : {},
    }
}

export default connect(mapStateToProps, null)(MyAuction)
